exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grid-detail table, .grid-detail .detail-content-wrap, .grid-detail .detail-content-item {\n  width: 100% !important;\n}\n.grid-detail img {\n  width: 100%;\n}\n.grid-attribute table {\n  width: 100% !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-ea464396","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/view/jingzhi/product/jingzhi_items.vue
// module id = 1726
// module chunks = 0